import Editor from "../components/richTextEditor/editor";
import { Hero } from "../layouts/hero";
import { MainLayout } from "../layouts/mainLayout";

function ContentEditor() {
  return (
    <MainLayout>
      <div className="main">
        <Hero
          title={"Rich Text Editor"}
          logo={false}
          desc={"Create and edit rich text content."}
        />
        <Editor />
      </div>
    </MainLayout>
  );
}

export default ContentEditor;
